// extracted by mini-css-extract-plugin
module.exports = {"filterSelect":"DynamicFilter_filterSelect__vTdeb"};